import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { del } from '../../actions/usedprocedurestep/delete';
import { reset, retrieve } from '../../actions/usedprocedurestep/show';
import { VersionLink as Link } from '../VersionLink';

class Show extends Component {
  static propTypes = {
    retrieved: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    eventSource: PropTypes.instanceOf(EventSource),
    retrieve: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    deleteError: PropTypes.string,
    deleteLoading: PropTypes.bool.isRequired,
    deleted: PropTypes.object,
    del: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.retrieve(decodeURIComponent(this.props.match.params.id));
  }

  componentWillUnmount() {
    this.props.reset(this.props.eventSource);
  }

  del = () => {
    if (window.confirm('Are you sure you want to delete this item?'))
      this.props.del(this.props.retrieved);
  };

  render() {
    if (this.props.deleted) return <Redirect to=".." />;

    const item = this.props.retrieved;

    return (
      <div>
        <h1>Show {item && item['@id']}</h1>

        {this.props.loading && (
          <div className="alert alert-info" role="status">
            Loading...
          </div>
        )}
        {this.props.error && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.error}
          </div>
        )}
        {this.props.deleteError && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.deleteError}
          </div>
        )}

        {item && (
          <table className="table table-responsive table-striped table-hover">
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">usedProcedure</th>
                <td>
                  {this.renderLinks('used_procedures', item['usedProcedure'])}
                </td>
              </tr>
              <tr>
                <th scope="row">procedureStep</th>
                <td>
                  {this.renderLinks('procedure_steps', item['procedureStep'])}
                </td>
              </tr>
              <tr>
                <th scope="row">isCompleted</th>
                <td>{item['isCompleted']}</td>
              </tr>
              <tr>
                <th scope="row">completedAt</th>
                <td>{item['completedAt']}</td>
              </tr>
              <tr>
                <th scope="row">createdBy</th>
                <td>{this.renderLinks('users', item['createdBy'])}</td>
              </tr>
              <tr>
                <th scope="row">updatedBy</th>
                <td>{this.renderLinks('users', item['updatedBy'])}</td>
              </tr>
              <tr>
                <th scope="row">position</th>
                <td>{item['position']}</td>
              </tr>
              <tr>
                <th scope="row">level</th>
                <td>{item['level']}</td>
              </tr>
              <tr>
                <th scope="row">createdAt</th>
                <td>{item['createdAt']}</td>
              </tr>
              <tr>
                <th scope="row">updatedAt</th>
                <td>{item['updatedAt']}</td>
              </tr>
            </tbody>
          </table>
        )}
        <Link to=".." className="btn btn-primary">
          Back to list
        </Link>
        {item && (
          <Link
            to={`/used_procedure_steps/edit/${encodeURIComponent(item['@id'])}`}
          >
            <button className="btn custom-btn-warning">Edit</button>
          </Link>
        )}
        <button onClick={this.del} className="btn btn-danger">
          Delete
        </button>
      </div>
    );
  }

  renderLinks = (type, items) => {
    if (Array.isArray(items)) {
      return items.map((item, i) => (
        <div key={i}>{this.renderLinks(type, item)}</div>
      ));
    }

    return (
      <Link to={`../${type}/show/${encodeURIComponent(items)}`}>{items}</Link>
    );
  };
}

const mapStateToProps = state => ({
  retrieved: state.usedprocedurestep.show.retrieved,
  error: state.usedprocedurestep.show.error,
  loading: state.usedprocedurestep.show.loading,
  eventSource: state.usedprocedurestep.show.eventSource,
  deleteError: state.usedprocedurestep.del.error,
  deleteLoading: state.usedprocedurestep.del.loading,
  deleted: state.usedprocedurestep.del.deleted
});

const mapDispatchToProps = dispatch => ({
  retrieve: id => dispatch(retrieve(id)),
  del: item => dispatch(del(item)),
  reset: eventSource => dispatch(reset(eventSource))
});

export default connect(mapStateToProps, mapDispatchToProps)(Show);
